import { useRef, useState, useEffect } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../../../Context/Context";
import imageImg from "../../../../../picture/slika.png";
import textImg from "../../../../../picture/text.png";
import wordImg from "../../../../../picture/word.png";
import pdfImg from "../../../../../picture/pdf.png";
import scanImg from "../../../../../picture/scan.png";
import editImg from "../../../../../picture/edit.png";
import uploadImg from "../../../../../picture/UploadDocument.png";
import downloadImg from "../../../../../picture/DownloadFile.png";
import visibleImg from "../../../../../picture/Visible.png";
import forwardImg from "../../../../../picture/forward.png";
import notificationImg from "../../../../../picture/notification.png";
import printImg from "../../../../../picture/print.png";
import letterAImg from "../../../../../picture/letterA.png";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";

const styles = {
  cell: { padding: "5px", textAlign: "center" },
  smallCell: { width: "40px", textAlign: "center", cursor: "pointer" },
  icon: { width: "30px", height: "30px" },
  filledDiv: { width: "25px", height: "25px", margin: "auto" }
};

function DokumentaEOpremaVazeca({ dokumenta: initialDocs }) {
  const { dictionary, baseUrl, apiKey, loggedUser } = useGlobalContext();

  useEffect(() => {
    console.log("=== DEBUG VAZECA DOKUMENTA ===");
    console.log("Svi dokumenti:", initialDocs);
    if (initialDocs[0]) {
      console.log("Prvi dokument:", initialDocs[0]);
      console.log("text:", initialDocs[0].text);
      console.log("word:", initialDocs[0].word);
      console.log("pdf:", initialDocs[0].pdf);
      console.log("image:", initialDocs[0].image);
      console.log("scan:", initialDocs[0].scan);
    }
  }, [initialDocs]);

  const [isOpenNotification, setIsOpenNotification] = useState(false);
  const [currentDocForAlarm, setCurrentDocForAlarm] = useState(null);
  const [alarmDays, setAlarmDays] = useState("");

  const handleOpenNotification = (doc) => {
    setCurrentDocForAlarm(doc);
    setAlarmDays(doc.notifikacija_dana || "30");
    setIsOpenNotification(true);
  };

  const handleSaveAlarm = async () => {
    const formData = new FormData();
    formData.append("document_id", currentDocForAlarm.id);
    formData.append("notifikacija_dana", alarmDays);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/update_document_alarm.php`,
        formData
      );
      if (data.status === 200) {
        setLocalDocs((prev) =>
          prev.map((d) =>
            d.id === currentDocForAlarm.id
              ? { ...d, notifikacija_dana: alarmDays }
              : d
          )
        );
        window.dispatchEvent(new Event("machineAdded"));
        setIsOpenNotification(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleShare = async (doc) => {
    const version = selectedField.documentType;
    const pathKey = `${version}_path`;
    const relativePath = doc[pathKey];

    if (!version || !relativePath) {
      alert(
        "Prvo selektujte verziju dokumenta (kockicu) koju želite da podelite."
      );
      return;
    }

    if (!navigator.canShare) {
      alert("Vaš browser ne podržava sistemsko deljenje fajlova.");
      return;
    }

    try {
      const fileUrl = `${baseUrl}/${relativePath}`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const fileName = relativePath.split("/").pop().replace(/^\d+_/, "");
      const file = new File([blob], fileName, { type: blob.type });

      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: doc.naziv,
          text: `Delim dokument: ${doc.naziv}`
        });
      } else {
        alert("Browser ne dozvoljava deljenje ovog tipa fajla.");
      }
    } catch (error) {
      console.error("Greška pri deljenju:", error);
      alert("Došlo je do greške. Pokušajte sa običnim preuzimanjem.");
    }
  };

  const handleDownload = () => {
    const doc = localDocs.find((d) => d.id === selectedField.documentId);

    if (!doc) {
      alert(
        "Prvo kliknite na kockicu (verziju) dokumenta koji želite da skinete."
      );
      return;
    }

    const pathKey = `${selectedField.documentType}_path`;
    const relativePath = doc[pathKey];

    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }

    window.open(
      `${baseUrl}/machines/download_document.php?path=${encodeURIComponent(relativePath)}`,
      "_blank"
    );
  };

  // Lokalni state - backend već šalje boje
  const [localDocs, setLocalDocs] = useState(initialDocs);
  const [selectedField, setSelectedField] = useState({
    documentId: "",
    documentType: ""
  });
  const [isOpenEditConfirm, setIsOpenEditConfirm] = useState(false);
  const [fileNewDocument, setFileNewDocument] = useState(null);
  const [newExpiryDate, setNewExpiryDate] = useState("");

  const fileInputRef = useRef();

  // Sinhronizacija ako roditelj pošalje nove podatke
  useEffect(() => {
    setLocalDocs(initialDocs);
  }, [initialDocs]);

  const handleSelectDocument = (docId, type) => {
    setSelectedField((prev) =>
      prev.documentId === docId && prev.documentType === type
        ? { documentId: "", documentType: "" }
        : { documentId: docId, documentType: type }
    );
  };

  const handleConfirmEdit = async () => {
    const formData = new FormData();
    formData.append("file", fileNewDocument);
    formData.append("document_id", selectedField.documentId);
    formData.append("document_type", selectedField.documentType);
    formData.append("datum_isteka", newExpiryDate);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/update_existing_document.php`,
        formData
      );
      if (data.status === 200) {
        setLocalDocs((prev) =>
          prev.map((d) =>
            d.id === selectedField.documentId
              ? { ...d, [selectedField.documentType]: "green" }
              : d
          )
        );

        window.dispatchEvent(new Event("machineAdded"));
        setIsOpenEditConfirm(false);
        setFileNewDocument(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const moveToArhivirani = async (doc) => {
    if (!window.confirm(`Arhivirati dokument: ${doc.naziv}?`)) return;

    setLocalDocs((prev) => prev.filter((d) => d.id !== doc.id));

    const formData = new FormData();
    formData.append("document_id", doc.id);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/archive_document.php`,
        formData
      );
      if (data.status === 200) {
        window.dispatchEvent(new Event("machineAdded"));
      } else {
        setLocalDocs(initialDocs);
      }
    } catch (error) {
      setLocalDocs(initialDocs);
      console.error(error);
    }
  };

  const handlePreview = (doc) => {
    const version = selectedField.documentType;
    const pathKey = `${version}_path`;
    const relativePath = doc[pathKey];

    if (!version || !relativePath) {
      alert(
        "Prvo selektujte verziju dokumenta (kockicu) koju želite da vidite."
      );
      return;
    }

    const fileUrl = `https://data.nadzor.app/${relativePath}`;
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const handlePrint = async (doc) => {
    const version = selectedField.documentType;
    const pathKey = `${version}_path`;
    const relativePath = doc[pathKey];

    if (!version || !relativePath) {
      alert("Prvo selektujte verziju dokumenta koju želite da odštampate.");
      return;
    }

    const rootUrl = baseUrl.split("/api")[0];
    const fullUrl = `${rootUrl}/${relativePath}`;

    try {
      const response = await fetch(fullUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = blobUrl;

      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        setTimeout(() => {
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(iframe);
        }, 2000);
      };
    } catch (error) {
      console.error("Greška pri štampi:", error);
      window.open(fullUrl, "_blank");
    }
  };

  return (
    <>
      <table style={{marginLeft: "95px", width: "90%"}}>
        <thead>
          <tr>
            <th style={styles.smallCell}>
              <img src={textImg} style={{ width: "30px" }} alt="text" />
            </th>
            <th style={styles.smallCell}>
              <img src={wordImg} style={{ width: "30px" }} alt="word" />
            </th>
            <th style={styles.smallCell}>
              <img src={pdfImg} style={{ width: "30px" }} alt="pdf" />
            </th>
            <th style={styles.smallCell}>
              <img src={imageImg} style={{ width: "30px" }} alt="img" />
            </th>
            <th style={styles.smallCell}>
              <img src={scanImg} style={{ width: "30px" }} alt="scan" />
            </th>
            <th style={{ ...styles.cell, width: "50%" }}>
              {dictionary["vazecaDokumenta"]}
            </th>
            <th colSpan="8">
              УПРАВЉАЊЕ
            </th>
          </tr>
        </thead>
        <tbody>
          {localDocs.map((doc) => (
            <tr key={doc.id}>
              {["text", "word", "pdf", "image", "scan"].map((type) => (
                <td
                  key={type}
                  onClick={() => handleSelectDocument(doc.id, type)}
                  style={{
                    ...styles.smallCell,
                    border:
                      selectedField.documentId === doc.id &&
                      selectedField.documentType === type
                        ? "2px solid black"
                        : ""
                  }}
                >
                  <div
                    style={{ ...styles.filledDiv, backgroundColor: doc[type] }}
                  ></div>
                </td>
              ))}
              <td style={styles.cell}>{doc.naziv}</td>
              <td style={styles.smallCell}>
                <img src={editImg} style={{ width: "30px" }} />
              </td>
              <td style={styles.smallCell} onClick={handleDownload}>
                <img src={downloadImg} style={{ width: "25px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => {
                  if (!selectedField.documentId) {
                    alert("Prvo odaberi verziju (kockicu)");
                    return;
                  }
                  fileInputRef.current.click();
                }}
              >
                <img src={uploadImg} style={{ width: "25px" }} />
              </td>
              <td style={styles.smallCell} onClick={() => handleShare(doc)}>
                <img src={forwardImg} style={{ width: "30px" }} alt="forward" />
              </td>
              <td style={styles.smallCell} onClick={() => handlePrint(doc)}>
                <img src={printImg} style={{ width: "20px" }} alt="print" />
              </td>
              <td style={styles.smallCell} onClick={() => handlePreview(doc)}>
                <img src={visibleImg} style={{ width: "30px" }} alt="preview" />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => moveToArhivirani(doc)}
              >
                <img src={letterAImg} style={{ width: "20px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => handleOpenNotification(doc)}
              >
                <img
                  src={notificationImg}
                  style={{ width: "30px" }}
                  alt="alarm"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            setFileNewDocument(file);
            setIsOpenEditConfirm(true);
          }
        }}
      />

      {isOpenEditConfirm && (
        <ConfirmationModal
          text="Potvrdite slanje i datum isteka:"
          handleConfirm={handleConfirmEdit}
          handleCancel={() => setIsOpenEditConfirm(false)}
        >
          <input
            type="date"
            value={newExpiryDate}
            onChange={(e) => setNewExpiryDate(e.target.value)}
            style={{ width: "100%", padding: "10px", marginTop: "10px" }}
          />
        </ConfirmationModal>
      )}
      {isOpenNotification && currentDocForAlarm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            fontSize: "larger"
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              width: "350px",
              fontSize: "larger",
              borderRadius: "10px",
              position: "relative"
            }}
          >
            {/* X button in top right corner */}
            <div
              onClick={() => setIsOpenNotification(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
                fontSize: "24px",
                fontWeight: "bold",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#000",
                fontWeight: "bold"
              }}
            >
              ✕
            </div>

            <div
              style={{
                ...styles.cell,
                border: "none",
                textAlign: "left",
                fontSize: "20px"
              }}
            >
              <div style={{ marginBottom: "5px" }}>
                Документ: <strong>{currentDocForAlarm.naziv}</strong>
              </div>
              <div style={{ marginBottom: "15px" }}>
                Истиче:{" "}
                <strong>
                  {currentDocForAlarm.datum_isteka || "Nije definisano"}
                </strong>
              </div>

              <label style={{ display: "block", marginBottom: "10px" }}>
                Аларм:
              </label>

              {/* Number controls and confirm button in same row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                  marginTop: "20px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}
                >
                  <button
                    onClick={() =>
                      setAlarmDays((prev) => Math.max(1, Number(prev) - 1))
                    }
                    style={{
                      width: "40px",
                      height: "40px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      cursor: "pointer"
                    }}
                  >
                    −
                  </button>

                  <input
                    type="number"
                    value={alarmDays}
                    onChange={(e) => setAlarmDays(e.target.value)}
                    className="dos-input"
                    style={{
                      width: "50px",
                      height: "40px",
                      padding: "8px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "bold",
                      boxSizing: "border-box"
                    }}
                  />

                  <button
                    onClick={() => setAlarmDays((prev) => Number(prev) + 1)}
                    style={{
                      width: "40px",
                      height: "40px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      cursor: "pointer"
                    }}
                  >
                    +
                  </button>
                </div>

                <div
                  className="dos-btn"
                  style={{
                    ...styles.smallCell,
                    padding: "10px 20px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    width: "150px",
                    height: "40px"
                  }}
                  onClick={handleSaveAlarm}
                >
                  ПОТВРДИ
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DokumentaEOpremaVazeca;
